<template>
  <!--begin::General Widget 1-->
  <v-container class="mb-10">
    <div class="">
      <div class="card-header border-0">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label page-title fw-bolder fs-3 mb-1"
            >Manage Promotional Codes</span
          >
        </h3>
      </div>
    </div>

    <div class="spacer-y-10"></div>

    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <span id="add-promotional-code" class="fw-bolder text-dark mt-7">{{
              modifyPromoCodeTitles.editComponentTitle
            }}</span>

            <div class="fv-row mt-8 mb-10 fv-plugins-icon-container">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                <span class="required">Promotional Code</span>
                <i
                  class="fas fa-exclamation-circle ms-2 fs-7"
                  data-bs-toggle="tooltip"
                  v-b-tooltip.hover
                  title="the promotional code users will enter"
                ></i>
              </label>
              <!--end::Label-->
              <!--begin::Input-->
              <input
                type="text"
                class="form-control form-control-lg form-control-solid"
                v-model="newPromoCode.code"
              />
              <!--end::Input-->
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>

            <div class="fv-row mt-8 mb-10 fv-plugins-icon-container">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                <span class="required">Description</span>
                <i
                  class="fas fa-exclamation-circle ms-2 fs-7"
                  data-bs-toggle="tooltip"
                  v-b-tooltip.hover
                  title="a description of the code that admins will see"
                ></i>
              </label>
              <!--end::Label-->
              <!--begin::Input-->
              <input
                type="text"
                class="form-control form-control-lg form-control-solid"
                v-model="newPromoCode.description"
              />
              <!--end::Input-->
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>

            <div class="row mt-8 mb-10 justify-content-between">
              <div class="col-sm-1"></div>
              <div class="col-sm-3">
                <label class="d-flex flex-stack cursor-pointer">
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <span class="fw-bolder fs-6"
                        >Single Use?
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="A one time use code"
                        ></i>
                      </span>
                    </span>
                  </span>

                  <span
                    class="form-check form-check-custom form-check-solid is-valid"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="singleUse"
                      v-model="newPromoCode.singleUse"
                    />
                  </span>
                </label>
              </div>
              <div class="col-sm-4">
                <label class="d-flex flex-stack cursor-pointer">
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <span class="fw-bolder fs-6"
                        >First Payment Only?
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="Should the discount only apply to the first payment?"
                        ></i>
                      </span>
                    </span>
                  </span>

                  <span
                    class="form-check form-check-custom form-check-solid is-valid"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="firstPaymentOnly"
                      v-model="newPromoCode.firstPayment"
                    />
                  </span>
                </label>
              </div>
              <div class="col-sm-1"></div>
            </div>

            <hr>

            <div class="fv-row mt-8 mb-10 fv-plugins-icon-container">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                <span class="required">Discount</span>
                <i
                  class="fas fa-exclamation-circle ms-2 fs-7"
                  data-bs-toggle="tooltip"
                  v-b-tooltip.hover
                  title="the discount entering the code will give users"
                ></i>
              </label>
              <!--end::Label-->

              <div class="row">
                <div class="col-sm-6">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Title</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      title="the title of the discount that will show up on user receipts"
                    ></i>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="newPromoCode.discount.name"
                  />
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
                <div class="col-sm-6">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Amount (USD)</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      title="the discount amount"
                    ></i>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="number"
                    class="form-control form-control-lg form-control-solid"
                    v-model.number="newPromoCode.discount.amount"
                  />
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Type</span>
                    <i
                      class="fas fa-exclamation-circle ms-2 fs-7"
                      data-bs-toggle="tooltip"
                      v-b-tooltip.hover
                      title="A fixed or percentage discount"
                    ></i>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <select
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="newPromoCode.discount.type"
                  >
                    <option
                      v-for="type in discountTypeOptions"
                      :key="type"
                      :value="type"
                    >
                      {{ type }}
                    </option>
                  </select>
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
              </div>

              <hr>
              <br>

              <div class="row">
                <div class="row justify-content-between">
                  <div class="col">
                    <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                      <span>End Date</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="An optional date to end the promo code"
                        ></i>
                    </label>
                  </div>
                  <div class="col text-end">
                    <button class="btn btn-secondary" @click="clearEndDate">Clear End Date</button>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-sm-6">
                  <v-date-picker
                    v-model="newPromoCode.endDate"
                ></v-date-picker>
                </div>
                </div>
              </div>
            </div>

            <button
              v-if="isAddingPromoCode"
              @click="codeConfirmation"
              :class="addPromoCodeBtnClass"
              :disabled="!this.isNewCodeValid || this.loading"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_confirm"
            >
              Add Promotional Code
              <span
                v-if="loading"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
              <svg
                v-if="!loading"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>

            <div v-else class="row">
              <div class="col-6">
                <button
                  @click="resetNewCode"
                  :disabled="this.loading"
                  class="btn fw-bold px-6 py-5 w-100 mb-4 mt-6 btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_confirm"
                >
                  Cancel
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                      stroke="#060606"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M14 8L8 14"
                      stroke="#060606"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8 8L14 14"
                      stroke="#060606"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
              <div class="col-6">
                <button
                  @click="codeConfirmation"
                  :class="addPromoCodeBtnClass"
                  :disabled="!this.isNewCodeValid || this.loading"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_confirm"
                >
                  Update Promotional Code
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-md align-middle ms-2"
                  ></span>
                  <svg
                    v-if="!loading"
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M7.04956 11.6921H14.9056"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>

            <div class="spacer-y-10"></div>
            <div class="spacer-y-10"></div>
            <div class="row">
              <div class="col-sm-7">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-sm-5 text-end">
                <a
                  @click="showReportModal = true"
                  class="btn btn-primary fw-bold"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_create_app"
                >
                  Export Report
                  <svg
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M7.04956 11.6921H14.9056"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>

            <v-data-table
              :headers="tableHeaders"
              :items="promotionalCodes"
              :search="search"
              item-key="Id"
              class="elevation-1"
              :loading="loadingPromoCodes"
              loading-text="Loading Promo Codes"
            >
              <template v-slot:[`item.discount.amount`]="{ item }">
                {{ formatDiscountAmount(item) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="col">
                  <button @click="edit(item.id)">Edit</button>
                </div>
                <div class="col">
                  <button @click="deleteCodeConfirmation(item)">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                        stroke="#060606"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14 8L8 14"
                        stroke="#060606"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M8 8L14 14"
                        stroke="#060606"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
        <PromoCodeReportModal
          v-model="showReportModal"
          :promoCodes="exportReportList"
          @closeModal="showReportModal = false"
        />
        <ConfirmationModal
          :isLoadingConfirmation="loadingConfirmation"
          :isShowDialog="isShowConfirmationModal"
          :btnConfig="buttonConfiguration"
          :inputInfo="confirmationModalInfo"
          :inputColor="confirmationModalInfoColor"
          @eConfirm="codeConfirmed"
          @eCancel="resetNewCode"
        />
        <SnackbarNotifier
          :isShow="isShowSnackBar"
          :message="responseMessage"
          :snackType="snackbarType"
          :colour="snackBarColour"
          @eReset="resetSnackBar"
        />
      </div>
      <!--end::Body-->
    </div>
  </v-container>
  <!--end::General Widget 1-->
</template>
<script>
import { ApiService, PromoCodeDiscountType } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import PromoCodeReportModal from "@/components/PromoCodeReportModal.vue";
import mixins from "vue-typed-mixins";
import { formatCurrency } from "@/mixins/shared";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManagePromotionalCodes",
  data() {
    return {
      loading: false,
      loadingPromoCodes: false,
      showReportModal: false,
      newPromoCode: {
        code: "",
        id: "",
        description: "",
        discount: {
          name: "",
          amount: 0,
          type: "Fixed",
        },
        singleUse: false,
        firstPayment: false,
        endDate: "",
      },
      deletePromoCodeId: "",
      search: "",
      tableHeaders: [
        { text: "Name", value: "code" },
        { text: "Uses", value: "uses" },
        { text: "Description", value: "description" },
        { text: "Title", value: "discount.name" },
        { text: "Discount", value: "discount.amount" },
        { text: "Action", value: "actions", align: "center" },
      ],
      promotionalCodes: [],
    };
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
    PromoCodeReportModal,
  },
  computed: {
    discountTypeOptions() {
      return Object.values(PromoCodeDiscountType);
    },
    isAddingPromoCode() {
      return !this.newPromoCode.id;
    },
    isDeleteingPromoCode() {
      return !!this.deletePromoCodeId;
    },
    modifyPromoCodeTitles() {
      if (this.isAddingPromoCode) {
        return {
          editComponentTitle: "Add Promotional Code",
          confirmationModal: {
            title: "Add Promotional Code",
            message: `Are you sure you want to add ${this.newPromoCode.code}?`,
          },
        };
      }

      return {
        editComponentTitle: "Update Promotional Code",
        confirmationModal: {
          title: "Update Promotional Code",
          message: `Are you sure you want to update ${this.newPromoCode.code}?`,
        },
      };
    },
    addPromoCodeBtnClass() {
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (!this.isNewCodeValid || this.loading)
        return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    },
    isNewCodeValid() {
      try {
        if (!this.newPromoCode.code) {
          return false;
        }

        if (
          this.isAddingPromoCode &&
          this.promotionalCodes.findIndex(
            (p) => p.code === this.newPromoCode.code
          ) > -1
        ) {
          return false;
        }

        if (this.newPromoCode.discount.amount < 0) {
          return false;
        }

        return !(
          this.newPromoCode.discount.amount > 0 &&
          !this.newPromoCode.discount.name
        );
      } catch (e) {}
      return false;
    },
    exportReportList() {
      if (!this.promotionalCodes || this.promotionalCodes.length < 0) {
        return [];
      }

      return this.promotionalCodes.map((p) => {
        return {
          code: p.code,
          id: p.id,
        };
      });
    },
  },
  methods: {
    clearEndDate(){
      this.newPromoCode.endDate = "";
    },
    formatDiscountAmount(item) {
      if (item.discount.type === PromoCodeDiscountType.Percentage) {
        return `${item.discount.amount}%`;
      }

      return formatCurrency(item.discount.amount);
    },
    codeConfirmation() {
      if (!this.validateData()) {
        return;
      }
      this.showConfirmationModal(this.modifyPromoCodeTitles.confirmationModal);
    },
    deleteCodeConfirmation(item) {
      this.deletePromoCodeId = item.id;
      this.showConfirmationModal({
        title: "Delete Promotional Code",
        message: `Are you sure you want to delte ${item.code}?`,
      });
    },
    async codeConfirmed() {
      if (this.isDeleteingPromoCode) {
        await this.deleteCode(this.deletePromoCodeId);
        return;
      }

      if (this.isAddingPromoCode) {
        await this.addCode(this.newPromoCode);
        return;
      }

      await this.updateCode(this.newPromoCode);
    },
    validateData() {
      try {
        if (!this.newPromoCode.code) {
          return false;
        }

        if (
          this.isAddingPromoCode &&
          this.promotionalCodes.findIndex(
            (p) => p.code === this.newPromoCode.code
          ) > -1
        ) {
          return false;
        }

        if (this.newPromoCode.discount.amount < 0) {
          return false;
        }

        if (
          this.newPromoCode.discount.amount > 0 &&
          !this.newPromoCode.discount.name
        ) {
          return false;
        }

        return true;
      } catch (e) {}
      return false;
    },
    resetNewCode() {
      this.newPromoCode = {
        code: "",
        description: "",
        id: "",
        uses: 0,
        discount: {
          name: "",
          amount: 0,
          type: "Fixed",
        },
      };
      this.deletePromoCodeId = "";
    },

    async addCode(newCode) {
      try {
        this.startConfirmationLoading();

        await ApiService.Instance.addPromoCode(newCode);
        this.promotionalCodes.push({ ...newCode, uses: 0 });

        this.showNotifier({
          message: `Successfully Added Promotional Code`,
          snackbarType: "success",
        });

        this.resetNewCode();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Add Promotional Code`,
          snackbarType: "error",
        });
        error(e);
      }
      this.stopConfirmationLoading();
    },
    edit(id) {
      try {
        const editedCode = this.promotionalCodes.find((p) => p.id === id);
        if (!editedCode) {
          return;
        }

        this.newPromoCode = {
          code: editedCode.code,
          description: editedCode.description,
          id: editedCode.id,
          uses: 0,
          discount: {
            name: editedCode,
            amount: 0,
            type: "Fixed",
          },
          singleUse: !!editedCode.singleUse,
          firstPayment: !!editedCode.firstPayment,
          endDate: editedCode.endDate ?? ""
        };

        if (editedCode.discount) {
          this.newPromoCode.discount = {
            name: editedCode.discount.name,
            amount: editedCode.discount.amount,
            type: editedCode.discount.type,
          };
        }

        const editPromoCodeComponent = document.getElementById(
          "add-promotional-code"
        );
        const top = editPromoCodeComponent.offsetTop;
        window.scroll(0, top);
      } catch (e) {
        error(e);
        this.resetNewCode();
      }
    },
    async updateCode(updateCode) {
      try {
        this.startConfirmationLoading();

        await ApiService.Instance.updatePromoCode(updateCode);
        await this.getPromotionalCodes();

        this.showNotifier({
          message: `Successfully Updated Promotional Code`,
          snackbarType: "success",
        });

        this.resetNewCode();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Update Promotional Code`,
          snackbarType: "error",
        });
        error(e);
      }
      this.stopConfirmationLoading();
    },
    async deleteCode(id) {
      try {
        this.startConfirmationLoading();

        await ApiService.Instance.deletePromoCode({ id });
        await this.getPromotionalCodes();

        this.showNotifier({
          message: `Successfully Deleted Promotional Code`,
          snackbarType: "success",
        });
      } catch (e) {
        this.showNotifier({
          message: `Failed To Delete Promotional Code`,
          snackbarType: "error",
        });
        error(e);
      }
      this.resetNewCode();
      this.stopConfirmationLoading();
    },
    async getPromotionalCodes() {
      try {
        this.loadingPromoCodes = true;
        this.promotionalCodes = await ApiService.Instance.retrievePromoCodes();
      } catch (e) {
        error(e);
      }
      this.loadingPromoCodes = false;
    },
  },
  async beforeMount() {
    try {
      await this.getPromotionalCodes();
    } catch (e) {
      error(e);
    }
  },
});
</script>
